import React, {Component} from 'react';
import FeedingGuidelinesHeader from './../FeedingGuidelinesHeader';
import FeedingGuidelinesIntro from './../FeedingGuidelinesIntro';
import FeedingGuidelinesProducts from './../FeedingGuidelinesProducts';
import FeedingGuidelinesNotes from './../FeedingGuidelinesNotes';
import FeedingGuidelinesRecommended from './../FeedingGuidelinesRecommended';
import FeedingGuidelinesPersonalizedNutrientProfile from './../FeedingGuidelinesPersonalizedNutrientProfile';
import FeedingGuidelinesDisclaimer from './../FeedingGuidelinesDisclaimer';

class Maintenance extends Component {

  render(){
    const {output} = this.props;

    return (
      <div data-type="lactation-pregnancy">
        <FeedingGuidelinesHeader output={output} />
        <FeedingGuidelinesIntro output={output} />
        <FeedingGuidelinesProducts output={output} />
        <div className="lactation-notes">
        <FeedingGuidelinesNotes output={output} />
        </div>

        <FeedingGuidelinesRecommended output={output} />

        <FeedingGuidelinesDisclaimer output={output} />
      </div>
    )
  }

}

export default (Maintenance);
